import { render, staticRenderFns } from "./disposeIdea.vue?vue&type=template&id=4f13b345&"
import script from "./disposeIdea.vue?vue&type=script&lang=js&"
export * from "./disposeIdea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/bhc/flow/disposeIdea.vue"
export default component.exports